import { render, staticRenderFns } from "./student.vue?vue&type=template&id=364b41d9"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports